import { useEffect, useRef, useState } from 'react';
import { useStore } from 'react-redux';
import commonUtil from '../../../common/commonUtil';
import messageConst from '../../../const/messageConst';
import { Label } from '../../atoms/label';
import { ModalClose } from '../../atoms/modalClose';
import './../../../resources_membership_hotel/css/popup/restaurantVacancyPopup.css';

const RestaurantVacancyPopupContainer = (props) => {
    const {
        state,
        onClickCloseRestaurantVacancyPopup,
    } = props;

    let restaurantVacancyPopup = state.restaurantVacancyPopup;

    const popupRef = useRef(null);

    const store = useStore();

    const login = store.getState().login;
    const loginType = login.loginType;
    const restaurantVacancyInfo = state.restaurantVacancyInfo;
    const restaurantInfo = state.restaurantInfo;
    const riyoDate = state.riyoDate;

    useEffect(() => {
        if (restaurantVacancyPopup) {
            popupRef.current.scrollTop = 0;
        }
    }, [restaurantVacancyPopup])

    return (
        <div className={restaurantVacancyPopup ? 'popupIsShow' : 'popup'} id='js-popup'>
            <div ref={popupRef} className='popupInner'>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickCloseRestaurantVacancyPopup()} />
                    <h4 className='popupInnerText' >空き時間</h4>
                </div>
                <div className='restaurantVacancy_restaurantInfo'>
                    <Label label={riyoDate ? commonUtil.getStringFromDateJpnMembership(riyoDate) : ""} />
                    <Label label={restaurantInfo.restaurantName} />
                </div>
                <div className='restaurantVacancy_tableWrap'>
                    <table className='restaurantVacancy_table'>
                        <colgroup>
                            <col className='restaurantVacancy_colgroupTime' />
                            <col className='restaurantVacancy_colgroupMark' />
                            {loginType == "CRAWL" ? 
                                restaurantVacancyInfo?.[0]?.takuList?.map(takuInfo =>
                                    <col className='restaurantVacancy_colgroup' />
                                )
                                : null
                            }

                        </colgroup>
                        <tr>
                            <th className='restaurantVacancy_tableHeaderColLeft' >
                                <Label
                                    label="開始時間"
                                    className="restaurantVacancy_tableHeaderLabel"
                                />
                            </th>
                            <th className='restaurantVacancy_tableHeaderColLeft' >
                                <Label
                                    label="空き"
                                    className="restaurantVacancy_tableHeaderLabel"
                                />
                            </th>
                            {loginType == "CRAWL" ?
                                restaurantVacancyInfo?.[0]?.takuList?.map(takuInfo =>
                                    <th key={takuInfo.takuCd} className='restaurantVacancy_tableHeaderCol'>{takuInfo.takuName}</th>
                                )
                                : null
                            }
                        </tr>
                        {restaurantVacancyInfo?.map(akijikan =>
                            <>
                                <tr >
                                    <td className="restaurantVacancy_tdColTime">
                                        <Label label={commonUtil.getTimeStr(akijikan.jikan, "hh:mm")} />
                                    </td>
                                    <td className="restaurantVacancy_tdColMark">
                                        <Label className={
                                            akijikan.kusekiMark == "×" ? "restaurantVacancy_cross" :
                                                akijikan.kusekiMark == "－" ? "restaurantVacancy_minus" :
                                                    akijikan.kusekiMark == "○" ? "restaurantVacancy_circle" :
                                                        akijikan.kusekiMark == "／" ? "restaurantVacancy_slash" :
                                                            ""
                                        } />
                                    </td>
                                    {loginType == "CRAWL" ?
                                        akijikan.takuList?.map((vacancy, index) =>
                                            <td key={vacancy.takuCd + index} className="restaurantVacancy_tdCol">
                                                <Label label={vacancy.kushitsuSu} />
                                            </td>
                                        )
                                        : null
                                    }
                                </tr>
                            </>
                        )}
                    </table>
                    <Label
                        label={restaurantInfo.restaurantSetsumei}
                        className={loginType == "CRAWL" ? "restaurantVacancy_restaurantSetsumei" : "hiddenItem"}
                    />
                    <Label
                        label={messageConst.RESTAURANT_VACANCY_MESSAGE}
                        className={loginType == "CRAWL" ? "restaurantVacancy_restaurantSetsumei" : "hiddenItem"}
                    />
                </div>
            </div>
            <div className='blackBackground' id='js-black-bg'></div>
        </div >
    );
};
export default RestaurantVacancyPopupContainer;